import React from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppRedux';
import { useI18n } from '../../hooks/useI18n';
import { setViewMode } from '../../redux/slices/previewSlice';
import { classNames } from '../../utils/classNames';
import { Tooltip } from './Tooltip';

const DesktopIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="2.75" y="3.75" width="18.5" height="12.5" rx="1.75" stroke="currentColor" strokeWidth="1.7" />
    <path d="M8 20.25h8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M12 16.25v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

const MobileIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="7.25" y="2.75" width="9.5" height="18.5" rx="2.25" stroke="currentColor" strokeWidth="1.7" />
    <path d="M10.5 18.75h3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

const options = [
  { value: 'desktop', titleKey: 'desktop', icon: DesktopIcon },
  { value: 'mobile', titleKey: 'mobile', icon: MobileIcon }
];

export const ViewSwitcher = ({ compact = false, iconOnly = false }) => {
  const dispatch = useAppDispatch();
  const { t } = useI18n();
  const viewMode = useAppSelector((state) => state.preview.viewMode);

  return (
    <div className="flex items-center">
      {options.map((option) => {
        const Icon = option.icon;
        const active = viewMode === option.value;
        const label = t(option.titleKey);

        return (
          <Tooltip key={option.value} content={label} position="bottom">
            <button
              type="button"
              onClick={() => dispatch(setViewMode(option.value))}
              aria-label={label}
              aria-pressed={active}
              className={classNames(
                'inline-flex h-8 items-center justify-center rounded-lg transition',
                iconOnly || compact ? 'w-8' : 'gap-1.5 px-2.5 text-xs font-medium',
                active
                  ? 'bg-neutral-100 text-neutral-900 dark:bg-accent-soft dark:text-text'
                  : 'text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700 dark:text-muted dark:hover:bg-accent-soft dark:hover:text-text'
              )}
            >
              <Icon />
              {iconOnly || compact ? null : <span>{label}</span>}
            </button>
          </Tooltip>
        );
      })}
    </div>
  );
};
